export default {
  name: 'CollaborationSelect',
  components: {},
  props: {
    value: {
      type: [String, Boolean],
    },
    error: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    capitalized: {
      type: Boolean,
      default: false,
    },
    capitalizedList: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  components: {},
  setup() {},
  data() {
    return {
      listOpen: false,
      search: '',
      selectedItems: [],
    }
  },
  created() {},
  mounted() {},
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (this.multiple && newVal) {
          const values = newVal.split(',').filter((v) => v.trim() !== '')
          this.selectedItems = []
          values.forEach((val) => {
            const option = this.options.find((opt) => opt.value === val.trim())
            if (option) {
              this.selectedItems.push(option)
            }
          })
          this.updateDisplayText()
        }
      },
    },
  },
  computed: {
    displayText() {
      if (!this.multiple) return this.search

      return this.selectedItems.length > 0 ? this.selectedItems.map((item) => item.text).join(', ') : this.search
    },
  },
  methods: {
    updateDisplayText() {
      if (this.multiple) {
        this.search = this.selectedItems.map((item) => item.text).join(', ')
      }
    },
    handleInput(event) {
      this.listOpen = true
      this.search = event.target.value

      if (!this.multiple) {
        this.$emit('input', event.target.value)
      }

      this.$emit('search', event.target.value)
    },
    handleBlur(event) {
      setTimeout(() => {
        this.listOpen = false
      }, 250)
    },
    reset() {
      this.search = ''
      this.selectedItems = []
    },
    selectOption(option) {
      if (this.multiple) {
        const index = this.selectedItems.findIndex((item) => item.value === option.value)

        if (index === -1) {
          this.selectedItems.push(option)
        } else {
          this.selectedItems.splice(index, 1)
        }

        const values = this.selectedItems.map((item) => item.value).join(',')
        this.$emit('input', values)
        this.$emit('item-selected', this.selectedItems)

        this.updateDisplayText()

        this.$nextTick(() => {
          if (this.$refs.inputField) {
            this.$refs.inputField.focus()
          }
        })
      } else {
        this.$emit('input', option.value)
        this.$emit('item-selected', option)
        this.search = option.text
        this.listOpen = false
        this.$nextTick(() => {
          if (this.$refs.inputField) {
            this.$refs.inputField.focus()
          }
        })
      }
    },

    removeItem(index) {
      this.selectedItems.splice(index, 1)

      const values = this.selectedItems.map((item) => item.value).join(',')
      this.$emit('input', values)
      this.$emit('item-selected', this.selectedItems)

      this.updateDisplayText()

      this.$nextTick(() => {
        if (this.$refs.inputField) {
          this.$refs.inputField.focus()
        }
      })
    },
  },
}
